// {
//   "name": "iconic-slideshow-first.js",
//   "author": "Arham Web Works"
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get("iconic-slideshow-first")) {
    return;
  }

  class IconicSlideshowFirst extends HTMLElement {
    constructor() {
      super();
      this.updateProgress = this.updateProgress.bind(this);
      this.onSectionLoad = this.onSectionLoad.bind(this);
    }

    connectedCallback() {
      this.currentSlideElement = this.querySelector(".current-slide");
      this.totalSlidesElement = this.querySelector(".total-slides");
      this.circleProgress = this.querySelector(".circle-progress");

      window.addEventListener("load", () => {
        this.initProgressBar();
      });

      document.addEventListener("shopify:section:load", this.onSectionLoad);
    }

    disconnectedCallback() {
      document.removeEventListener("shopify:section:load", this.onSectionLoad);
    }

    onSectionLoad(event) {
      if (event.target.contains(this)) {
        this.initProgressBar();
      }
    }

    initProgressBar() {
      const swiperElements = document.querySelectorAll(".swiper-container");
      
      swiperElements.forEach((swiperElement) => {
        if (swiperElement.swiper) {
          const swiper = swiperElement.swiper;
          
          swiper.on("autoplayStart", () => this.updateProgress(swiperElement, swiper));
          swiper.on("slideChange", () => this.updateProgress(swiperElement, swiper));
          
          this.updateProgress(swiperElement, swiper);
        } else {
          setTimeout(() => this.initProgressBar(), 100);
        }
      });
    }

    updateProgress(swiperElement, swiper) {
      const totalSlides = swiper.slides.length;
      const currentSlide = swiper.realIndex + 1;
      const progressPercent = (totalSlides / totalSlides) * 100;

      const currentSlideEl = swiperElement.closest("iconic-slideshow-first")?.querySelector(".current-slide");
      const totalSlidesEl = swiperElement.closest("iconic-slideshow-first")?.querySelector(".total-slides");
      const circleProgressEl = swiperElement.closest("iconic-slideshow-first")?.querySelector(".circle-progress");

      if (!currentSlideEl || !totalSlidesEl || !circleProgressEl) return;

      currentSlideEl.textContent = currentSlide;
      totalSlidesEl.textContent = totalSlides;

      const radius = parseFloat(circleProgressEl.getAttribute("r"));
      const circleLength = 2 * Math.PI * radius;

      circleProgressEl.style.transition = "none";
      circleProgressEl.style.strokeDasharray = circleLength;
      circleProgressEl.style.strokeDashoffset = circleLength;

      const speed = parseFloat(swiperElement.getAttribute("data-speed")) || 4.3;

      requestAnimationFrame(() => {
        circleProgressEl.style.transition = `stroke-dashoffset ${speed}s linear`;
        const strokeOffset = circleLength - (progressPercent / 100) * circleLength;
        circleProgressEl.style.strokeDashoffset = strokeOffset;
      });
    }
  }

  customElements.define("iconic-slideshow-first", IconicSlideshowFirst);
})();